import { getCsrfValue } from "../../../../api/ApiHelper";

import { resolveApiUrl } from "../../../../utils/url/urlResolver";

export const deleteAddress = (data: {}, id: string, isTemporary: boolean): Promise<any> => {
  const apiUrl = resolveApiUrl(`/ship/to/address/${id}/${isTemporary}`);
  return fetch(apiUrl, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
};
